import Auth from '../../auth/AuthHelper';
import {fetchAuthSession, getCurrentUser} from 'aws-amplify/auth';
import {
  Linking,
  Alert,
  Platform,
  PermissionsAndroid,
  View,
  ActivityIndicator,
  Text,
} from 'react-native';
import { Geo } from '@aws-amplify/geo'; // Changed import
import Geolocation from 'react-native-geolocation-service';
import React, {useCallback} from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import mystyles from '../../assets/styles/mystyles';




export async function getUserId() {
  const user = await Auth.getCurrentUser(); // returns null if no session
  return user?.username;
}

export async function getUserIdEmailPhone () {
  try {
    const user = await Auth.getCurrentUser()
    const userId = user?.username;
    // Capture the values from getEmailAndPhone
    const { email, phone } = await Auth.getEmailAndPhone();

    return {userId, email, phone}

  } catch (e) {
    console.warn('Failed to get user info', e);
  }
}

export async function getEmailPhone () {
  try {

    // Capture the values from getEmailAndPhone
    const { email, phone } = await Auth.getEmailAndPhone();

    return { email, phone}

  } catch (e) {
    console.warn('Failed to get user info', e);
  }
}

// javascript
// Centralized API configuration

export const API_BASE_URL = 'https://api.eabu.net';

// Replace with your real key via secure config/injection at build time
export const API_KEY = 'FG4UEKGXZq2yDMYCFiWvJ2apOlnFtKbP9HhARSLD'; // e.g., injected by your CI or env solution
export const API_KEY_HEADER = 'x-api-key'; // Change to 'Authorization' if your API expects Bearer tokens
/**
 * Get a Cognito JWT from the current session.
 * @param {'id'|'access'} type
 * @param {{ forceRefresh?: boolean }} opts
 * @returns {Promise<string>}
 */
// Add these helpers (outside the component)
export async function getToken(type = 'id', opts = {}) {
  const { forceRefresh = false } = opts;
  const { tokens } = await fetchAuthSession({ forceRefresh });
  if (!tokens) throw new Error('No active session. User is not signed in.');

  const jwt = type === 'access'
    ? tokens.accessToken?.toString()
    : tokens.idToken?.toString();

  if (!jwt) throw new Error(`Requested ${type} token is not available.`);
  return jwt;
}

// Helper to get the logged-in user's unique ID (Cognito "sub")
export async function getLoggedInUserId() {
  try {
    const { tokens } = await fetchAuthSession();
    return tokens?.idToken?.payload?.sub || '';
  } catch {
    return '';
  }
}


export async function callApi(method, pathOrUrl, { body, headers, tokenType = 'id' } = {}) {
  const isAbsolute = /^https?:\/\//i.test(pathOrUrl);
  const base = API_BASE_URL.replace(/\/+$/, '');
  const path = String(pathOrUrl).replace(/^\/+/, '');
  const url = isAbsolute ? pathOrUrl : `${base}/${path}`;

  const makeRequest = async (forceRefresh = false) => {
    const token = await getToken(tokenType, { forceRefresh });
    const userId = await getUserId()


    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-User-Id': userId,       // <-- logged in user id added here
        ...(headers || {}),
      },
      body: body != null ? JSON.stringify(body) : undefined,
    });
    return res;
  };

  // First attempt
  let res = await makeRequest(false);

  // Retry once on 401 with a forced refresh
  if (res.status === 401) {
    res = await makeRequest(true);
  }

  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`Request failed (${res.status}): ${txt || res.statusText}`);
  }



  // Parse JSON if possible
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return res.json();
  }
  return res.text();
}



export function formatDate(value) {
  const d = value ? new Date(value) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'long' }).replace(' ', ', ');
}

// export async function formatDate(value) {
//   if (!value) return '';
//   try {
//     // Accept ISO string or epoch (seconds or milliseconds)
//     const n = typeof value === 'string' ? Number(value) : value;
//     let d;
//     if (!Number.isNaN(n)) {
//       const ms = n < 1e12 ? n * 1000 : n;
//       d = new Date(ms);
//     } else {
//       d = new Date(value);
//     }
//     if (Number.isNaN(d.getTime())) return '';
//     return d.toLocaleDateString(); // Use toLocaleString() if you want date + time
//   } catch {
//     return '';
//   }
// };
// Helper to normalize various date formats (ISO string, epoch sec/ms)
export function getTimeMs (value)  {
  if (value == null) return 0;
  if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))) {
    const n = Number(value);
    return n < 1e12 ? n * 1000 : n; // seconds -> ms
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
};


export const callPhone = async (raw) => {
  if (!raw) return;
  const phone = String(raw).replace(/[^\d+]/g, '');
  if (!phone) return;

  const url = `tel:${phone}`;
  try {
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
    } else {
      Alert.alert('Calling not supported', 'This device cannot make phone calls.');
    }
  } catch (e) {
    Alert.alert('Error', 'Unable to start the call.');
    console.warn('Failed to start call', e);
  }
};


export const performFollow = async (item, cUserId, cEmail, cPhone, setFollowBusy, rowKey) => {
  try {
    if (cUserId === item?.userId) {
      Alert.alert('Error', 'You cannot follow yourself.');
      return;
    }

    setFollowBusy(prev => ({ ...prev, [rowKey]: true }));

    const payload = {
      pUserId: item?.userId ?? '',
      cUserId: cUserId ?? '',
      cEmail: cEmail ?? '',
      cPhone: cPhone ?? ''
    };

    await callApi('POST', '/eabu-follow', { body: payload });

    Alert.alert(
      'Success',
      'You are now following this service provider.',
    );
  } catch (e) {
    if (e.message === 'Request failed (400):{"message":"Already following this user"}') {
      Alert.alert(
        'Already following',
        'You are already following this service provider. Thank you for following.',
      );
    } else {
      Alert.alert('Follow failed', e.message ?? e.toString() ?? 'Unknown error');
    }
  } finally {
    setFollowBusy(prev => ({ ...prev, [rowKey]: false }));
  }
};

export const getZipCodeAws = async (latitude, longitude) => {
  try {

    // 1. Ensure valid session exists before calling Geo
    // If you allow unauthenticated (Guest) access, this refreshes guest creds too.
    // If you require login, this ensures the token is valid.
    const session = await fetchAuthSession();
    console.log('Credentials refreshed:', session.credentials);

    const results = await Geo.searchByCoordinates([longitude, latitude]); // Note: Longitude comes first in AWS Geo!

    if (results && results.length > 0) {
      const zip = results[0].postalCode;
      console.log('ZIP Code:', zip);
      return zip;
    }
  } catch (error) {
    console.error(error);
  }
};


export const getLatLong = () => {
      const {latitude, longitude} = Geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // Use latitude and longitude for reverse geocoding
        },
        (error) => console.log(error),
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 }
      );
      return {latitude, longitude};
}

export const getZipcodeFromCoordinates= async (latitude, longitude) =>{
  try {
    const results = await Geo.searchByCoordinates([longitude, latitude]);

    if (results) {
      const zipcode = results.postalCode;
      if (zipcode.includes('-')) {
        // Truncate the string to keep only the first 5 characters
        return zipcode.substring(0, 5);
      }
      return zipcode; // Example: Assuming 'postalCode' property exists
    }
    return null;
  } catch (error) {
    console.error("Error during reverse geocoding:", error);
    return null;
  }
}

export const getUserAddress= async (latitude, longitude) =>{
  try {
    const results = await Geo.searchByCoordinates([longitude, latitude]);
    let address = "";
    if (results) {
      address = results.addressNumber + " " + results.street + ", "+ results.municipality + ", " + results.region + ", " + results.country + " " + results.postalCode;

    }
    return address;
  } catch (error) {
    console.error("Error during reverse geocoding:", error);
    return null;
  }

}

export const handleShowInMap = async (address) => {
  if (!address) return;
  // Construct Google Maps URL query
  const query = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${query}`;

  Linking.openURL(mapUrl).catch(err => console.error('An error occurred', err));
}

export const handleVerifyUser = async (pUserId) => {
  if (!pUserId) return;
  try {
    const response = await callApi('GET', '/eabu-identity-check/' + encodeURIComponent(pUserId));
    const items = response?.Items || [];
    const result = items[0] || { submitted: false, verified: false };

    const isVerified = !!result?.verified;
    const addr = result?.address || '';
    //call map shower
    await handleShowInMap(addr)

    if (!isVerified) {
      Alert.alert('Identity Check', 'This seller could not be verified.');
    }
  } catch (e) {
    Alert.alert('Identity Check Error', e?.message || 'Unable to verify this seller at the moment.');
  }
}

export async function requestLocationPermission (){
  if (Platform.OS === 'android') {
    try {
      const fine = PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION;
      const coarse = PermissionsAndroid.PERMISSIONS.ACCESS_COARSE_LOCATION;
      const result = await PermissionsAndroid.requestMultiple([fine, coarse]);
      const grantedFine = result[fine] === PermissionsAndroid.RESULTS.GRANTED;
      const grantedCoarse = result[coarse] === PermissionsAndroid.RESULTS.GRANTED;
      return grantedFine || grantedCoarse;
    } catch {
      return false;
    }
  } else {
    const auth = await Geolocation.requestAuthorization('whenInUse');
    return auth === 'granted';
  }
}

export async function fetchAndStoreZipCode() {
  try {
    // Start permission check and auth session refresh in parallel
    const [hasPermission] = await Promise.all([
      requestLocationPermission(),
      fetchAuthSession()
    ]);

    if (!hasPermission) return;

    // Use a Promise to await the location fastest way possible
    const position = await new Promise((resolve, reject) => {
      Geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false, // Much faster: uses Wi-Fi/Cell towers instead of waiting for GPS satellite lock
        timeout: 5000,             // Short timeout to fail fast and potentially retry or fallback
        maximumAge: 600000,        // Cache for 10 minutes: if we have a recent location, use it instantly
      });
    });

    const { latitude, longitude } = position.coords;

    // Reverse geocode
    const response = await Geo.searchByCoordinates([longitude, latitude]);


    const zipCode = response?.postalCode;

    if (zipCode) {
      const formattedZip = zipCode.split('-')[0].substring(0, 5);

      // Fast check: Only write to storage if the value changed
      const currentZip = await AsyncStorage.getItem('session_zipcode');
      if (currentZip !== formattedZip) {
        await AsyncStorage.setItem('session_zipcode', formattedZip);
      }
    }
  } catch (error) {
    // Silently fail or log for debugging; speed is priority
    console.debug('Fast ZIP fetch failed:', error);
  }
}

export async function setCurrentZipCode(currentZipcode) {
  try {
    await AsyncStorage.setItem('session_zipcode', currentZipcode);
  } catch (e) {
    console.log('Error fetching zipcode:', e);
  }
  return null;
}

export async function  handleInterested  (item,activeSection)  {
  let category = '';
  if (activeSection === 'FOOD') category = 'eat';
  else if (activeSection === 'HOUSEHOLD') category = 'live';
  else if (activeSection === 'TRANSPORT') category = 'move';

  const cUserId = await getUserId();

  const payload = {
    zipcode: item.zipcode,
    ID: item.ID,
    interested: (Number(item.interested_by) || 0) + 1,
    providerType: category,
    cUserId: cUserId,
  };

  try {
    const response = await callApi('POST', '/eabu-update-interested', { body: payload });

  } catch (e) {
    return ('Error updating interest:', e);
  }
  return true
};


